import { CFormInput, CFormLabel } from '@coreui/react'
import React from 'react'

function UpdatePin({ changePinCredential, setChangePinCredential }) {
    return (
        <div className='fields-container'>
            <div className='mb-3 mt-3'>
                <div>
                    <CFormLabel>PIN <span className="text-danger">*</span></CFormLabel>
                </div>
                <div className='w-100'>
                    <CFormInput
                        type='password'
                        pattern='\d*'
                        minLength={4}
                        maxLength={4}
                        value={changePinCredential.newPin}
                        onChange={(e) => setChangePinCredential({ ...changePinCredential, newPin: e.target.value })}
                        required
                        feedbackInvalid='Please enter a PIN with 4 digit.'
                        className='is_not_validated'
                    />
                </div>
            </div>
            <div className='mb-3 mt-3'>
                <div>
                    <CFormLabel>Confirm PIN <span className="text-danger">*</span></CFormLabel>
                </div>
                <div className='w-100'>
                    <CFormInput
                        type='password'
                        pattern='\d*'
                        minLength={4}
                        maxLength={4}
                        value={changePinCredential.confirmNewPin}
                        onChange={(e) => setChangePinCredential({ ...changePinCredential, confirmNewPin: e.target.value })}
                        required
                        feedbackInvalid='Please enter a confirm PIN with 4 digit.'
                        className='is_not_validated'
                    />
                </div>
            </div>
        </div>
    )
}

export default UpdatePin